export default __webpack_public_path__ + "static/media/projectthree.ca46c303.jpg";